export default __webpack_public_path__ + "static/media/black-friday-2026-bg-desktop.7e6ff381.jpg";